import api from "../../api";
import { isManuallyCreated } from "../../helpers/person.helpers";

export const isManuallyUpdated = (entity: api.Role | api.Owner) =>
  !isManuallyCreated(entity) && Boolean(entity.updated_by);
